module.exports = __webpack_public_path__ + "static/media/logoBoutique.90b84c5f.png";